module.exports = __webpack_public_path__ + "static/img/asp.ef690235.png";